import { SEARCH_SORT_OPTIONS } from '../constants/search'
import '../styles/product-filter-sort.scss'

export type ProductFilterSortBarProps = {
  sort: string
  onChange: (nextSort: string) => void
  totalCount?: number
}

export function ProductFilterSortBar({
  sort,
  onChange,
  totalCount,
}: ProductFilterSortBarProps) {
  return (
    <div className="product-filter-bar">
      <div className="product-filter-bar__top">
        {typeof totalCount === 'number' && (
          <span className="product-filter-bar__count">
            {totalCount} {totalCount === 1 ? 'product' : 'products'}
          </span>
        )}

        <div className="product-filter-bar__sort">
          <label htmlFor="product-sort-select" className="product-filter-bar__sort-label">
            Sort by:
          </label>
          <select
            id="product-sort-select"
            value={sort}
            onChange={(e) => onChange(e.target.value)}
            className="product-filter-bar__select"
          >
            {SEARCH_SORT_OPTIONS.map((opt) => (
              <option key={opt.key} value={opt.key}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}
